module.exports = __webpack_public_path__ + "static/media/5.91d2567a.jpg";